import React, { useEffect, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import Btn from "components/Custom/Btn";
import Loader from "components/Custom/Loader";
import TxtBox from "components/Custom/TxtBox";
import ExcelGrid from "components/Custom/ExcelGrid";
import TripReceiptForm from "./TripReceiptForm";

import { ApiIndents } from "apihandlers//indent";
import { DEFAULTS, FORMATS } from "common/config";
import { LABELS, SUB_TITLES } from "common/labels";
import { DateFunctions } from "common/datefunctions";
import { GOPAL_SNACKS } from "common/config";

const ApiIndentHandler = new ApiIndents();

const TripReceipt = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = () => {
    const fromDate = (
      document.getElementById("fromDate") as HTMLInputElement
    ).value.trim();
    const toDate = (
      document.getElementById("toDate") as HTMLInputElement
    ).value.trim();
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      nofuel: 1,
      fromDate,
      toDate,
      isPaymentText: "false",
    };
    setRows(null);
    ApiIndentHandler.getIndentPayments(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log("onEditRow:", row);
  };

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      editable: false,
      sortable: true,
      align: "center",
      searchable: true,
    },
    {
      key: "indentGroup",
      name: LABELS.TRIP,
      type: "text",
      width: "27%",
      editable: false,
      sortable: true,
      align: "center",
      searchable: true,
    },
    {
      key: "driverName",
      name: LABELS.DRIVERS_NAME,
      type: "text",
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      searchable: true,
    },
    {
      key: "customerName",
      name: LABELS.CUSTOMER,
      type: "text",
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      searchable: true,
    },
    {
      key: "chargesName",
      name: LABELS.CATEGORY,
      type: "text",
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      searchable: true,
    },
    {
      key: "amount",
      name: LABELS.AMMOUNT,
      width: "11%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "paymentMode",
      name: GOPAL_SNACKS?LABELS.TRANSACTION_MODE_OF_GOPAL: LABELS.PAYMENT_MODE,
      type: "dropdown",
      width: "11%",
      editable: false,
      sortable: true,
      align: "center",
      filters: GOPAL_SNACKS?[
        {
          id: "RAJKOT",
          name: "RAJKOT",
        },
        {
          id: "MODASA",
          name: "MODASA",
        },
        {
          id: "NAGPUR",
          name: "NAGPUR",
        },
  
      ]:[
        {
          id: "cash",
          name: "CASH",
        },
        {
          id: "bank",
          name: "BANK",
        },
        {
          id: "upi",
          name: "UPI",
        },
        {
          id: "card",
          name: "CARD",
        },
        {
          id: "none",
          name: "NONE",
        },
      ],

      searchable: true,
    },
    {
      key: "activeStatus",
      name: LABELS.ACTIVE_STATUS,
      type: "dropdown",
      width: "11%",
      editable: false,
      sortable: true,
      align: "center",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      searchable: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li
            onClick={() => {
              setDashMenu(LABELS.HOME);
            }}
          >
            {LABELS.TRANSACTIONS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">
            {LABELS.TRANSACTION_BUTTON_EXPENSE_RECEIPT}
          </li>
        </ul>
        <h4>{LABELS.TRANSACTION_BUTTON_EXPENSE_RECEIPT}</h4>
        <p className="SubTitles">{SUB_TITLES.USERS}</p>
      </div>
      <div id="chartForm">
        <div
          className="formGroup"
          style={{
            display: "flex",
            marginTop: 5,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <label
              style={{
                fontWeight: "500",
                fontSize: 18,
                marginTop: 6,
                marginRight: 10,
              }}
            >
              {LABELS.FROM_DATE}
            </label>
            <TxtBox
              id={"fromDate"}
              type={"datetime-local"}
              defaultValue={DateFunctions.getDate(
                "lastmonth",
                "to",
                FORMATS.SQL_DATE
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 18,
                marginTop: 6,
                marginRight: 10,
              }}
            >
              {LABELS.TO_DATE}
            </label>
            <TxtBox
              id={"toDate"}
              type={"datetime-local"}
              defaultValue={DateFunctions.getDate(
                "thismonth",
                "to",
                FORMATS.SQL_DATE
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
            }}
          >
            <Btn text={LABELS.LOAD} onClick={getRows} />
          </div>
        </div>
      </div>
      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.TRANSACTION_BUTTON_EXPENSE_RECEIPT}
            height={window.innerHeight * 0.8}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.TRANSACTION_BUTTON_EXPENSE_RECEIPT}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <TripReceiptForm
          selectedRow={selectedRow}
          defaultValues={{}}
          setSelectedRow={setSelectedRow}
          setManageDialog={setManageDialog}
          reloadGrid={reloadGrid}
          onEditRow={onEditRow}
        />
      )}
    </React.Fragment>
  );
};

export default withSnackbar(TripReceipt);
